<div class="container">
    <div class="col">
        <h1 class="greenTitle">{{titleGreen}}</h1>
        <h1 class="blackTitle">{{titleBlack}}</h1>
    </div>
    <div class="col">
        <p>{{text}}</p>
        <a class="primary-btn-arrow" [routerLink]="link">{{buttonText}}</a>
    </div>
</div>